import {UIElement} from "./ui";
import flatpickr from "/node_modules/flatpickr";
import '/node_modules/flatpickr/dist/flatpickr.css';
import '../css/ui/datepicker.css';
import {nnTrim} from "../util";
import {dateFromStr, formatDate, formatTimestamp} from "../time/TimeCalculator";

class CalendarDatePicker extends UIElement {

    constructor(id, placeholder, value, justDate=true) {
        super(id);
        this.placeholder = placeholder;
        this.value = justDate?formatDate(value):formatTimestamp(value);
        this.onChangeCallbacks = new Set();
        this.justDate=justDate;
    }

    getClassName() {
        return "CalendarDatePicker";
    }

    getValue(){
        const val = nnTrim(this.value);
        return val ? dateFromStr(val) : undefined;
    }

    setInputReadonly(readonly){
        this.inputReadonly = !!readonly;
        return this;
    }

    getUIElement() {
        if (!this.uiElement) {
            const input = $('<input autocomplete="off" type="text" id="' + this.id + '"/>')
                .attr('placeholder', this.placeholder)
                .val(this.value)
                .change(() => {
                    this.value = $('input',this.uiElement).val();
                    this._handleClearVisibility();
                    this.onChangeCallbacks.forEach(c => c(this.getValue()));
                });
            if(this.inputReadonly){
                input.attr('disabled','disabled').attr('readonly','readonly');
            }
            this.uiElement = $('<div class="date-picker"></div>').append(input);
            if(!this.inputReadonly) {
                const clearButton = $('<span class="clear">x</span>');
                this.uiElement.append(clearButton);
                const calendar = flatpickr(input,{
                    time_24hr: true,
                    enableTime: !this.justDate,
                    dateFormat: !this.justDate?"Y-m-d H:i":"Y-m-d",
                    defaultHour: 0
                });
                calendar.config.onChange.push(()=>this.logStat("PICK"));
                clearButton.click(() => {
                    calendar.clear();
                    this.logStat("CLEAR")
                    return false;
                });
                this._handleClearVisibility();
            }
        }
        return this.uiElement;
    }

    _handleClearVisibility(){
        if(this.value)
            $('.clear',this.uiElement).show();
        else $('.clear',this.uiElement).hide();
    }

    onChange(callback) {
        if(callback)
            this.onChangeCallbacks.add(callback);
        return this;
    }
}

export {CalendarDatePicker}
